var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports", "./Button", "./InputField"], function (require, exports, Button_1, InputField_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Controlbar = void 0;
    class Controlbar extends Autodesk.Viewing.UI.ToolBar {
        constructor(viewer, guiExtension, coreExtension) {
            super('MarkupsGuiControlbar');
            this.groupControlId = 'MarkupsGuiToolbarControlGroup';
            this.markupsExtension = coreExtension;
            this.guiExtension = guiExtension;
            this.container.style.top = '10px';
            this.container.style.bottom = 'auto';
            this.container.style.right = '10px';
            this.container.style.left = 'auto';
            this.container.style.width = 'auto';
            const groupControl = new Autodesk.Viewing.UI.ControlGroup(this.groupControlId);
            const undoBtn = Button_1.createButton({
                code: 'undo',
                name: 'Undo',
                icon: '<-',
                action: () => {
                    this.markupsExtension.undo();
                },
            }, guiExtension, coreExtension);
            const redoBtn = Button_1.createButton({
                code: 'redo',
                name: 'Redo',
                icon: '->',
                action: () => {
                    this.markupsExtension.redo();
                },
            }, guiExtension, coreExtension);
            groupControl.addControl(undoBtn);
            groupControl.addControl(redoBtn);
            if (guiExtension.options.showNameInput) {
                // todo
                this.createNameInput(groupControl);
            }
            groupControl.addControl(Button_1.createButton({
                code: 'exit',
                name: 'Abbrechnen',
                action: () => {
                    guiExtension.deactivateTools();
                },
            }, guiExtension, coreExtension));
            if (guiExtension.options.showSaveButton) {
                this.createSaveButton(groupControl);
            }
            this.addControl(groupControl);
            viewer.container.appendChild(this.container);
            // @ts-ignore
            this.markupsExtension.addEventListener(Autodesk.Viewing.Extensions.Markups.Core.EVENT_HISTORY_CHANGED, () => __awaiter(this, void 0, void 0, function* () {
                yield this.toggleHistory(undoBtn, redoBtn);
            }));
        }
        createNameInput(groupControl) {
            const options = {
                index: 2,
            };
            groupControl.addControl(new InputField_1.InputField('markup-title', 'Name Markierung'), options);
        }
        createSaveButton(groupControl) {
            groupControl.addControl(Button_1.createButton({
                code: 'save',
                name: 'Speichern',
                action: () => __awaiter(this, void 0, void 0, function* () {
                    const markupsData = yield this.guiExtension.getData();
                    // empty markup title validation
                    if (markupsData.name === '') {
                        alert('Bitte geben Sie einen Namen für die neue Markierung ein.'); // Please insert a name for the new markup
                        return;
                    }
                    if (this.guiExtension.options.saveHandler) {
                        // todo
                        this.guiExtension.options.saveHandler(markupsData.data, markupsData.viewerState, markupsData.name);
                    }
                    this.guiExtension.deactivateTools();
                }),
            }, this.guiExtension, this.markupsExtension));
        }
        toggleHistory(btnUndo, btnRedo) {
            return __awaiter(this, void 0, void 0, function* () {
                btnUndo.setState(this.markupsExtension.isUndoStackEmpty()
                    ? Autodesk.Viewing.UI.Button.State.DISABLED
                    : Autodesk.Viewing.UI.Button.State.INACTIVE);
                btnRedo.setState(this.markupsExtension.isRedoStackEmpty()
                    ? Autodesk.Viewing.UI.Button.State.DISABLED
                    : Autodesk.Viewing.UI.Button.State.INACTIVE);
            });
        }
        getGroupControl() {
            return this.getControl(this.groupControlId);
        }
        getNameInput(groupControl) {
            if (!groupControl) {
                groupControl = this.getGroupControl();
            }
            return groupControl === null || groupControl === void 0 ? void 0 : groupControl.getControl('markup-title');
        }
        syncOptions() {
            const groupControl = this.getGroupControl();
            const saveBtn = groupControl.getControl('markups-save');
            if (!this.guiExtension.options.showSaveButton && saveBtn) {
                groupControl.removeControl(saveBtn);
            }
            else if (this.guiExtension.options.showSaveButton && !saveBtn) {
                this.createSaveButton(groupControl);
            }
            const nameInput = this.getNameInput(groupControl);
            if (!this.guiExtension.options.showNameInput && nameInput) {
                groupControl.removeControl(nameInput);
            }
            else if (this.guiExtension.options.showNameInput && !nameInput) {
                this.createNameInput(groupControl);
            }
        }
    }
    exports.Controlbar = Controlbar;
});
//# sourceMappingURL=Controlbar.js.map